import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { useEffect, useState } from "react";
import { CardBody, CardHeader, Col, Row } from "react-bootstrap";
import { find, get, includes, isEmpty } from "lodash";
import { request } from "../../../../utils/Request";
import { formatDate, utcDateToLocalDate } from "../../../../utils/Helper";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const TravelOrderDetail = (props: any) => {
    const { t, toastify, params } = props;
    const [entity, setEntity] = useState<any>(null);

    const getDetail = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/travel/orders/${ id }`
            });

            const { data } = response.data;
            setEntity(data);
        } catch (error) {
            toastify(t("server error"), "error");
        }
    };

    useEffect(() => {
        if ( includes(['detail'], get(params, ['operation'])) ) {
            getDetail(params.operationId);
        }
    }, [params]);

    return (
        <div className={ "p-4 bg-white" }>
            {
                entity &&
              <>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('travel order number') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.travel_order_number }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('departure date') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ formatDate(entity.departure_date, 'DD-MM-YYYY HH:mm') }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('return date') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ formatDate(entity.return_date, 'DD-MM-YYYY HH:mm') }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('transport vehicle') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['transport_vehicle', 'truck_plate_number']) } | { get(entity, ['transport_vehicle', 'trailer_plate_number']) }
                          </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('legal entity') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['legal_entity', 'company_name']) }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('start mileage') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['start_mileage']) }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('end mileage') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['end_mileage']) }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('total kilometers') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['total_kilometers']) }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('revenue') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['revenue']) }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('coefficient') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['coefficient']) }</div>
                      </Col>
                  </Row>

                  <Col md={ 7 } lg={ 8 } sm={ 12 } className={ "mb-4" }>
                      <Card>
                          <CardHeader>
                              <h5 className={ "mb-0" }>{ t('connected loads') }</h5>
                          </CardHeader>
                          <CardBody className={ "mt-3" }>
                              <DataTable value={ entity.load_orders } editMode="row" dataKey="id">
                                  <Column field="load_type" header={ t('load type') }
                                          body={ (rowData: any) => rowData.load_type } />
                                  <Column field="load_number" header={ t('load number') }
                                          body={ (rowData: any) => rowData.load_number } />
                                  <Column field="route_title" header={ t('route') }
                                          body={ (rowData: any) => rowData.route_title } />
                                  <Column field="total_km" header={ t('total km') }
                                          body={ (rowData: any) => rowData.total_km } />
                                  <Column field="start_meter" header={ t('start meter') }
                                          body={ (rowData: any) => rowData.start_meter } />
                                  <Column field="end_meter" header={ t('end meter') }
                                          body={ (rowData: any) => rowData.end_meter } />
                              </DataTable>
                          </CardBody>
                      </Card>
                  </Col>
              </>
            }
        </div>
    );
};

TravelOrderDetail.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(TravelOrderDetail));
